<template>
    <div class="main-content email-signature">
        <div class="mb-3">
            <h4>VECTOR VIEWER</h4>
            <p class="diagonal-lines"></p>
        </div>
        <div v-if="loading" class="vh-100 d-flex justify-content-center align-items-center">
            <vue-loaders-ball-beat scale="2" color="black" />
        </div>

        <div v-else>
            <form method="post" enctype="multipart/form-data" name="upload-logo-form" id="upload-logo-form" data-hs-cf-bound="true">

                <section v-if="outputFile">
                    <div class="upload-box">
                        <div class="converted-file">
                            <div><span @click="startOver"><i class="fas fa-times"></i></span>
                            <img :src="'/'+outputFile" alt="outputFile"></div>
                            <a :href="'/'+outputFile" class="button button-small mt-3" download>DOWNLOAD IMAGE</a>
                        </div>
                    </div>
                </section>
                <section v-else>
                    <div class="upload-box">
                        <div>
                            <label id="upload-txt" class="upload-txt" for="upload-logo">
                                <h3>
                                    <img src="/images/icon-upload-cloud.png" alt="upload logo" @click.prevent="uploadFile"><br>
                                    CLICK TO VIEW VECTOR ARTWORK<br>
                                    <span>(EPS, AI, PDF)</span><br>
                                    <strong v-if="error" class="upload-error"><i class="fas fa-exclamation-circle"></i> {{ error }}</strong>
                                    <input type="file" ref="uploadFile" id="upload-logo" class="upload-logo" name="upload-logo" @change="convertFile">
                                </h3>
                            </label>
                        </div>
                    </div>
                </section>
            </form>
        </div>

    </div>
</template>
<script>

export default {
    data() {
        return {
            loading:false,
            error:null,
            outputFile:null,
        };
    },
    methods:{
        startOver(){
            this.outputFile=null;
        },
        uploadFile(){
            this.$refs.uploadFile.click();
        },
        async convertFile(event) {

            const file = event.target.files[0];
            console.log(file);

            // Check if a file is selected
            if (file) {
                const allowedFormats = ['esp', 'pdf', 'ai'];
                const fileSizeLimit = 4 * 1024 * 1024; // 4MB in bytes

                const fileExtension = file.name.split('.').pop().toLowerCase();
                const fileSize = file.size;

                // Check file format
                if (allowedFormats.includes(fileExtension)) {
                // Check file size
                if (fileSize <= fileSizeLimit) {
                    this.error=null;
                    this.loading=true;
                    // console.log('File format and size are valid.');
                    // TODO: Handle the valid file here
                    const formData = new FormData();
                    formData.append('file', file);

                    //Convert file in jpg format
                    await axios.post(`/api/convertFile`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response =>{
                        this.outputFile=response.data.filePath;
                        this.loading=false;
                    })
                    .catch(error=>{
                        this.error='Error uploading file. Please try again.';
                        this.loading=false;
                    });
                    console.log(this.outputFile);
                } else {
                    this.error='File size exceeds the limit of 4MB.';
                    // TODO: Handle the file size exceeded case here
                }
                } else {
                    this.error='Invalid file format. Only ESP, PDF, and AI formats are allowed.';
                // TODO: Handle the invalid file format case here
                }
            } else {
                this.error='No file selected.';
                // TODO: Handle the case where no file is selected here
            }




        }
    }
}
</script>
